var QRCodeErrorLevel;
(function (QRCodeErrorLevel) {
    /** 30% of data bytes can be restored. */
    QRCodeErrorLevel["HIGH"] = "H";
    /** 7% of data bytes can be restored. */
    QRCodeErrorLevel["LOW"] = "L";
    /** 15% of data bytes can be restored. */
    QRCodeErrorLevel["MEDIUM"] = "M";
    /** 25% of data bytes can be restored. */
    QRCodeErrorLevel["QUARTILE"] = "Q";
})(QRCodeErrorLevel || (QRCodeErrorLevel = {}));
/* eslint-disable typescript-sort-keys/string-enum */
var QRCodeSize;
(function (QRCodeSize) {
    QRCodeSize["XSMALL"] = "64";
    QRCodeSize["SMALL"] = "128";
    QRCodeSize["MEDIUM"] = "256";
    QRCodeSize["LARGE"] = "512";
    QRCodeSize["XLARGE"] = "1024";
})(QRCodeSize || (QRCodeSize = {}));
/* eslint-enable */
export { QRCodeErrorLevel, QRCodeSize, };
//# sourceMappingURL=qrcode-constants.js.map